document.addEventListener('DOMContentLoaded', () => {
    const variantSelect = document.querySelector('.variant-select.size-swatch-pdp');
    const options = variantSelect.querySelectorAll('.variant-select__list li');


    const button = variantSelect.querySelector('button');

    button.addEventListener('click', (event) => {
        event.stopPropagation();

        const content = variantSelect.querySelector('.variant-select__content');
        const height = content.scrollHeight;
        content.style.setProperty('--max-height', height + 'px');

        const isExpanded = variantSelect.getAttribute('aria-expanded') === 'true';

        document.querySelectorAll('.variant-select').forEach(el => {
            el.setAttribute('aria-expanded', 'false');
        });

        variantSelect.setAttribute('aria-expanded', !isExpanded);
    });

    options.forEach((option) => {
        option.addEventListener('click', (event) => {
            variantSelect.setAttribute('aria-expanded', 'false');
            let getValue = option.querySelector('input').value;
            variantSelect.querySelector('button .variant-select__option-value').textContent = getValue;
            let getInput = document.querySelector(`.variant-option.size-variant input[value="${getValue}"]`);
            getInput.click();

            let getVariantAvailable = getInput.getAttribute('data-option-available') === 'true';
            let getNotifyMe = variantSelect.querySelector('.variant-select__option-note');
            let getQuantity = getInput.getAttribute('data-product-inventory')

            if(!getVariantAvailable) {
                variantSelect.querySelector('.variant-select__option-value').classList.add('variant-select__option-value--unavailable')
                getNotifyMe.textContent = "Notify me";
            } else {
                variantSelect.querySelector('.variant-select__option-value').classList.remove('variant-select__option-value--unavailable')
                getNotifyMe.textContent = "";
            }


            if (getVariantAvailable && getQuantity === '1') {
                getNotifyMe.textContent = "ONLY ONE LEFT";
            } else if (!getVariantAvailable) {
                getNotifyMe.textContent = "Notify me";
            } else {
                getNotifyMe.textContent = "";
            }

        })
    })

    const colorSelect = document?.querySelector('.variant-select.color-swatch-pdp');

    if(colorSelect) {
    const colorButton = colorSelect?.querySelector('button');
        colorButton.addEventListener('click', (event) => {
            event.stopPropagation();

            const content = colorSelect.querySelector('.variant-select__content');
            const height = content.scrollHeight;
            content.style.setProperty('--max-height', height + 'px');

            const isExpanded = colorSelect.getAttribute('aria-expanded') === 'true';

            document.querySelectorAll('.variant-select').forEach(el => {
                el.setAttribute('aria-expanded', 'false');
            });

            colorSelect.setAttribute('aria-expanded', !isExpanded);
        });
    }

    document.addEventListener('click', () => {
        document.querySelectorAll('.variant-select').forEach(el => {
            el.setAttribute('aria-expanded', 'false');
        });
    });

    const getProductThumbnails = document.querySelectorAll('.product__thumbnails-container .product__thumbnails .product__media-thumbnail');

    getProductThumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', (event) => {
            event.preventDefault();

            const mediaId = thumbnail.getAttribute('data-media-id');

            const target = document.querySelector(
                `.product__media .product__media-item[data-media-id="${mediaId}"]`
            );

            const container = document.querySelector('.product__media');

            if (target && container) {
                container.scrollTo({
                    top: target.offsetTop,
                    behavior: 'smooth'
                });
            }
        });
    });
    const mediaContainer = document.querySelector('.product__media');

    mediaContainer.addEventListener('scroll', () => {

        const isAtBottom = mediaContainer.scrollHeight - mediaContainer.scrollTop <= mediaContainer.clientHeight + 1;

        if (isAtBottom) {
            mediaContainer.style.scrollSnapType = 'none';
        } else {
            mediaContainer.style.scrollSnapType = 'y mandatory';
        }
    });
})